import React, { useEffect, useState } from 'react';

export const VideoContent = ({ fileBlob }: { fileBlob: Blob | null }) => {
    const [videoSrc, setVideoSrc] = useState<string | null>(null);

    useEffect(() => {
        if (fileBlob) {
            const objectUrl = URL.createObjectURL(fileBlob);
            setVideoSrc(objectUrl);

            return () => {
                URL.revokeObjectURL(objectUrl);
            };
        }
        return null;
    }, [fileBlob]);

    if (!videoSrc) {
        return <div>Loading...</div>;
    }

    return (
        <video controls width="100%" height="100%">
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support the video tag.
        </video>
    );
};
